import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import styles from "./../../style.module.scss";
import { useTranslation } from "react-i18next";
import { Button, Modal, Card, Row, Col, Space, Spin } from "antd";

// redux & query
import { setInspectModalVisible } from "../../goSlice";
import { useAppSelector, useAppDispatch } from "store/hook";
import { useInspect } from "../../queries";

const InspectModal: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { ticket } = useParams();

  const [error, setError] = useState<any>(null);

  const { deviceId, ticketData, inspectModalVisible } = useAppSelector((state) => state.goPage);
  const {
    isLoading: loading,
    isSuccess,
    isRefetching: refetching,
    data: inspectResult,
    refetch,
  } = useInspect(ticketData?.ticket_inf?.cid, ticket, deviceId);

  useEffect(() => {
    setError("");
    refetch()
      .then((res: any) => {
        // console.log("res", res);
        res.error.response.status === 400 && setError(t("ISMS.DeviceNoResponse"));
      })
      .catch((err) => {
        // console.log("err", err);
      });
  }, []);

  // SIM1
  // SIM1 APN1
  const sim1 = inspectResult?.sim?.[0]?.status === "not inserted";
  const sim1_status =
    inspectResult?.sim?.[0]?.status.charAt(0).toUpperCase() + inspectResult?.sim?.[0]?.status?.slice(1);
  const sim1_signal =
    inspectResult?.sim?.[0]?.signal === 4
      ? "Excellent"
      : inspectResult?.sim?.[0]?.signal === 3
      ? "Good"
      : inspectResult?.sim?.[0]?.signal === 2
      ? "Fair"
      : inspectResult?.sim?.[0]?.signal === 1
      ? "Poor"
      : "NA";
  const sim1_access = inspectResult?.sim?.[0]?.access;
  const sim1_apn1 = inspectResult?.interface?.sim?.[0]?.apn?.[0]?.state === "disabled";
  const sim1_apn1_name = inspectResult?.interface?.sim?.[0]?.apn?.[0]?.APN; // APN#1: internet
  const sim1_apn1_active = inspectResult?.sim?.[0]?.apn?.[0]?.active;
  const sim1_apn1_state =
    inspectResult?.interface?.sim?.[0]?.apn?.[0]?.state.charAt(0).toUpperCase() +
    inspectResult?.interface?.sim?.[0]?.apn?.[0]?.state.slice(1); // up or disabled -> disabled 不顯示
  const sim1_apn1_ip_address = inspectResult?.interface?.sim?.[0]?.apn?.[0]?.ipv4_address; // IP Address: 10.2.5.10
  const sim1_apn1_ping1 = inspectResult?.interface?.sim?.[0]?.apn?.[0]?.checks?.[0]?.target;
  const sim1_apn1_ping1_sent = inspectResult?.interface?.sim?.[0]?.apn?.[0]?.checks?.[0]?.statistics?.sent;
  const sim1_apn1_ping1_received = inspectResult?.interface?.sim?.[0]?.apn?.[0]?.checks?.[0]?.statistics?.received;
  const sim1_apn1_ping2 = inspectResult?.interface?.sim?.[0]?.apn?.[0]?.checks?.[1]?.target;
  const sim1_apn1_ping2_sent = inspectResult?.interface?.sim?.[0]?.apn?.[0]?.checks?.[1]?.statistics?.sent;
  const sim1_apn1_ping2_received = inspectResult?.interface?.sim?.[0]?.apn?.[0]?.checks?.[1]?.statistics?.received;
  // SIM1 APN1
  const sim1_apn2 = inspectResult?.interface?.sim?.[0]?.apn?.[1]?.state === "disabled";
  const sim1_apn2_name = inspectResult?.interface?.sim?.[0]?.apn?.[1]?.APN; // APN#1: internet
  const sim1_apn2_active = inspectResult?.sim?.[0]?.apn?.[1]?.active;
  const sim1_apn2_state =
    inspectResult?.interface?.sim?.[0]?.apn?.[1]?.state.charAt(0).toUpperCase() +
    inspectResult?.interface?.sim?.[0]?.apn?.[1]?.state.slice(1); // up or disabled -> disabled 不顯示
  const sim1_apn2_ip_address = inspectResult?.interface?.sim?.[0]?.apn?.[1]?.ipv4_address; // IP Address: 10.2.5.10
  const sim1_apn2_ping1 = inspectResult?.interface?.sim?.[0]?.apn?.[1]?.checks?.[0]?.target;
  const sim1_apn2_ping1_sent = inspectResult?.interface?.sim?.[0]?.apn?.[1]?.checks?.[0]?.sent;
  const sim1_apn2_ping1_received = inspectResult?.interface?.sim?.[0]?.apn?.[1]?.checks?.[0]?.received;
  const sim1_apn2_ping2 = inspectResult?.interface?.sim?.[0]?.apn?.[1]?.checks?.[1]?.target;
  const sim1_apn2_ping2_sent = inspectResult?.interface?.sim?.[0]?.apn?.[1]?.checks?.[1]?.sent;
  const sim1_apn2_ping2_received = inspectResult?.interface?.sim?.[0]?.apn?.[1]?.checks?.[1]?.received;

  // SIM2
  // SIM2 APN1
  const sim2 = inspectResult?.sim?.[1]?.status === "not inserted";
  const sim2_status =
    inspectResult?.sim?.[1]?.status.charAt(0).toUpperCase() + inspectResult?.sim?.[1]?.status?.slice(1);
  const sim2_signal =
    inspectResult?.sim?.[1]?.signal === 4
      ? "Excellent"
      : inspectResult?.sim?.[1]?.signal === 3
      ? "Good"
      : inspectResult?.sim?.[1]?.signal === 2
      ? "Fair"
      : inspectResult?.sim?.[1]?.signal === 1
      ? "Poor"
      : "NA";
  const sim2_access = inspectResult?.sim?.[1]?.access;
  const sim2_apn1 = inspectResult?.interface?.sim?.[1]?.apn?.[0]?.state === "disable";
  const sim2_apn1_name = inspectResult?.interface?.sim?.[1]?.apn?.[0]?.APN; // APN#1: internet
  const sim2_apn1_active = inspectResult?.sim?.[1]?.apn?.[0]?.active;
  const sim2_apn1_state =
    inspectResult?.interface?.sim?.[1]?.apn?.[0]?.state.charAt(0).toUpperCase() +
    inspectResult?.interface?.sim?.[1]?.apn?.[0]?.state.slice(1); // up or disabled -> disabled 不顯示
  const sim2_apn1_ip_address = inspectResult?.interface?.sim?.[1]?.apn?.[0]?.ipv4_address; // IP Address: 10.2.5.10
  const sim2_apn1_ping1 = inspectResult?.interface?.sim?.[1]?.apn?.[0]?.checks?.[0]?.target; // Ping 8.8.8.8:
  const sim2_apn1_ping1_sent = inspectResult?.interface?.sim?.[1]?.apn?.[0]?.checks?.[0]?.sent; // Sent: 3
  const sim2_apn1_ping1_received = inspectResult?.interface?.sim?.[1]?.apn?.[0]?.checks?.[0]?.received; // Received: 3
  const sim2_apn1_ping2 = inspectResult?.interface?.sim?.[1]?.apn?.[0]?.checks?.[1]?.target; // Ping 8.8.8.8:
  const sim2_apn1_ping2_sent = inspectResult?.interface?.sim?.[1]?.apn?.[0]?.checks?.[1]?.sent; // Sent: 3
  const sim2_apn1_ping2_received = inspectResult?.interface?.sim?.[1]?.apn?.[0]?.checks?.[1]?.received; // Received: 3
  // SIM2 APN2
  const sim2_apn2 = inspectResult?.interface?.sim?.[1]?.apn?.[1]?.state === "disable";
  const sim2_apn2_name = inspectResult?.interface?.sim?.[1]?.apn?.[1]?.APN; // APN#1: internet
  const sim2_apn2_active = inspectResult?.sim?.[1]?.apn?.[1]?.active;
  const sim2_apn2_state =
    inspectResult?.interface?.sim?.[1]?.apn?.[1]?.state.charAt(0).toUpperCase() +
    inspectResult?.interface?.sim?.[1]?.apn?.[1]?.state.slice(1); // up or disabled -> disabled 不顯示
  const sim2_apn2_ip_address = inspectResult?.interface?.sim?.[1]?.apn?.[1]?.ipv4_address; // IP Address: 10.2.5.10
  const sim2_apn2_ping1 = inspectResult?.interface?.sim?.[1]?.apn?.[1]?.checks?.[0]?.target; // Ping 8.8.8.8:
  const sim2_apn2_ping1_sent = inspectResult?.interface?.sim?.[1]?.apn?.[1]?.checks?.[0]?.sent; // Sent: 3
  const sim2_apn2_ping1_received = inspectResult?.interface?.sim?.[1]?.apn?.[1]?.checks?.[0]?.received; // Received: 3
  const sim2_apn2_ping2 = inspectResult?.interface?.sim?.[1]?.apn?.[1]?.checks?.[1]?.target; // Ping 8.8.8.8:
  const sim2_apn2_ping2_sent = inspectResult?.interface?.sim?.[1]?.apn?.[1]?.checks?.[1]?.sent; // Sent: 3
  const sim2_apn2_ping2_received = inspectResult?.interface?.sim?.[1]?.apn?.[1]?.checks?.[1]?.received; // Received: 3

  // WAN
  const wan_state = inspectResult?.interface?.wan?.state;
  const wan_active = inspectResult?.interface?.wan?.active;
  const wan_status =
    inspectResult?.interface?.wan?.status === "off"
      ? "Down"
      : inspectResult?.interface?.wan?.status.charAt(0).toUpperCase() + inspectResult?.interface?.wan?.status.slice(1); //   Status: 100M Full IP
  const wan_ip_address = inspectResult?.interface?.wan?.ipv4_address; // Address: 20.9.9.9
  const wan_gateway = inspectResult?.interface?.wan?.checks
    ?.map((item: any, index: number) => {
      if (item.is_gateway) return true;
      else return false;
    })
    .indexOf(true);
  const wan_ping1 = inspectResult?.interface?.wan?.checks?.[0]?.target; // Ping 8.8.8.8:
  const want_ping1_sent = inspectResult?.interface?.wan?.checks?.[0]?.statistics?.sent; // Sent: 3
  const want_ping1_received = inspectResult?.interface?.wan?.checks?.[0]?.statistics?.received; // Received: 3
  const wan_ping2 = inspectResult?.interface?.wan?.checks?.[1]?.target; // Ping 8.8.8.8:
  const want_ping2_sent = inspectResult?.interface?.wan?.checks?.[1]?.statistics?.sent; // Sent: 3
  const want_ping2_received = inspectResult?.interface?.wan?.checks?.[1]?.statistics?.received; // Received: 3
  const wan_ping3 = inspectResult?.interface?.wan?.checks?.[2]?.target; // Ping 8.8.8.8:
  const want_ping3_sent = inspectResult?.interface?.wan?.checks?.[2]?.statistics?.sent; // Sent: 3
  const want_ping3_received = inspectResult?.interface?.wan?.checks?.[2]?.statistics?.received; // Received: 3

  // LAN
  const lan1 =
    inspectResult?.interface?.lan?.status?.[0] === "off"
      ? "Down"
      : inspectResult?.interface?.lan?.status?.[0]?.charAt(0).toUpperCase() +
        inspectResult?.interface?.lan?.status?.[0]?.slice(1);
  const lan2 =
    inspectResult?.interface?.lan?.status?.[1] === "off"
      ? "Down"
      : inspectResult?.interface?.lan?.status?.[1]?.charAt(0).toUpperCase() +
        inspectResult?.interface?.lan?.status?.[1]?.slice(1);
  const lan3 =
    inspectResult?.interface?.lan?.status?.[2] === "off"
      ? "Down"
      : inspectResult?.interface?.lan?.status?.[2]?.charAt(0).toUpperCase() +
        inspectResult?.interface?.lan?.status?.[2]?.slice(1);

  const handleOk = () => {
    dispatch(setInspectModalVisible(false));
  };

  const handleCancel = () => {
    dispatch(setInspectModalVisible(false));
  };

  return (
    <>
      <Modal
        title={t("ISMS.InspectResult")}
        visible={inspectModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        className={styles.modalWrap}
        footer={[
          <Button
            key="Retry"
            onClick={() => {
              refetch();
            }}
            disabled={loading || refetching ? true : false}
          >
            {t("ISMS.Retry")}
          </Button>,
          <Button
            type="primary"
            key="Submit"
            onClick={() => {
              handleCancel();
            }}
          >
            {t("ISMS.Confirm")}
          </Button>,
        ]}
      >
        {loading || refetching ? (
          <>
            <Row justify="center" align="middle" style={{ height: "40vh" }}>
              <Col>
                <Spin className={styles.loadingSpin} />
              </Col>
            </Row>
          </>
        ) : !isSuccess ? (
          <>
            <Row justify="center" align="middle" style={{ height: "40vh" }}>
              <Col style={{ fontSize: "16px" }}>{`${error}`}</Col>
            </Row>
          </>
        ) : (
          <div className="formwrap">
            <Row gutter={[24, 24]} justify="center" style={{ paddingLeft: "35px" }}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <h2>SIM#1 Status {(sim1_apn1_active && `(Active)`) || (sim1_apn2_active && `(Active)`)}</h2>
                <Row className={styles.inspectRow}>
                  {!sim1 ? (
                    <>
                      <Col span={24} className={styles.colFontSize}>
                        Status: {`${sim1_status}`}
                      </Col>
                      <Col span={24} className={styles.colFontSize}>
                        Signal: {`${sim1_signal}`}
                      </Col>
                      <Col span={24} className={styles.colFontSize}>
                        Modem Access: {`${sim1_access}`}
                      </Col>

                      <Space direction="vertical" size="middle" style={{ display: "flex" }}>
                        <div>
                          <Col span={24} className={styles.colFontSize}>
                            APN#1: {!sim1_apn1 ? sim1_apn1_name : sim1_apn1_state} {sim1_apn1_active && `(Active)`}
                          </Col>

                          <div
                            style={{
                              display: sim1_apn1_state !== "disabled" ? "" : "none",
                            }}
                          >
                            <Col
                              span={24}
                              className={styles.colFontSize}
                              style={{ display: sim1_apn1_ip_address !== undefined ? "" : "none" }}
                            >
                              IP Address: {`${sim1_apn1_ip_address}`}
                            </Col>
                            <Col span={24}>
                              <Row style={{ display: sim1_apn1_ping1 !== undefined ? "" : "none" }}>
                                <Col span={24} className={styles.colFontSize}>
                                  Ping {`${sim1_apn1_ping1}`}:
                                </Col>
                              </Row>
                              <Row
                                className={styles.inspectRow}
                                style={{ display: sim1_apn1_ping1 !== undefined ? "" : "none" }}
                              >
                                <Col span={24} className={styles.colFontSize}>
                                  Sent: {`${sim1_apn1_ping1_sent}`}, Received: {`${sim1_apn1_ping1_received}`}
                                </Col>
                              </Row>
                            </Col>
                            <Col span={24}>
                              <Row style={{ display: sim1_apn1_ping2 !== undefined ? "" : "none" }}>
                                <Col span={24} className={styles.colFontSize}>
                                  Ping {`${sim1_apn1_ping2}`}:
                                </Col>
                              </Row>
                              <Row className={styles.inspectRow}>
                                <Col
                                  span={24}
                                  className={styles.colFontSize}
                                  style={{ display: sim1_apn1_ping2 !== undefined ? "" : "none" }}
                                >
                                  Sent: {`${sim1_apn1_ping2_sent}`}, Received: {`${sim1_apn1_ping2_received}`}
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        </div>

                        <div>
                          <Col span={24} className={styles.colFontSize}>
                            APN#2: {!sim1_apn2 ? sim1_apn2_name : sim1_apn2_state} {sim1_apn2_active && `(Active)`}
                          </Col>
                          <div style={{ display: sim1_apn2_state !== "Disabled" ? "" : "none" }}>
                            <Col
                              span={24}
                              className={styles.colFontSize}
                              style={{ display: sim1_apn2_ip_address !== undefined ? "" : "none" }}
                            >
                              IP Address: {`${sim1_apn2_ip_address}`}
                            </Col>
                            <Col span={24}>
                              <Row>
                                <Col span={24} className={styles.colFontSize}>
                                  Ping {`${sim1_apn2_ping1}`}:
                                </Col>
                              </Row>
                              <Row className={styles.inspectRow}>
                                <Col span={24} className={styles.colFontSize}>
                                  Sent: {`${sim1_apn2_ping1_sent}`}, Received: {`${sim1_apn2_ping1_received}`}
                                </Col>
                              </Row>
                            </Col>
                            <Col span={24}>
                              <Row>
                                <Col span={24} className={styles.colFontSize}>
                                  Ping {`${sim1_apn2_ping2}`}:
                                </Col>
                              </Row>
                              <Row className={styles.inspectRow}>
                                <Col span={24} className={styles.colFontSize}>
                                  Sent: {`${sim1_apn2_ping2_sent}`}, Received: {`${sim1_apn2_ping2_received}`}
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        </div>
                      </Space>
                    </>
                  ) : (
                    <Col span={24} className={styles.colFontSize}>
                      Status: SIM card is not inserted
                    </Col>
                  )}
                </Row>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <h2>SIM#2 Status {(sim2_apn1_active && `(Active)`) || (sim2_apn2_active && `(Active)`)}</h2>
                <Row className={styles.inspectRow}>
                  {!sim2 ? (
                    <>
                      <Col span={24} className={styles.colFontSize}>
                        Status: {`${sim2_status}`}
                      </Col>
                      <Col span={24} className={styles.colFontSize}>
                        Signal: {`${sim2_signal}`}
                      </Col>
                      <Col span={24} className={styles.colFontSize}>
                        Modem Access: {`${sim2_access}`}
                      </Col>

                      <Space direction="vertical" size="middle" style={{ display: "flex" }}>
                        <div style={{ display: sim2_apn1_state !== "disabled" ? "" : "none" }}>
                          <Col span={24} className={styles.colFontSize}>
                            APN#1: {!sim2_apn1 ? sim2_apn1_name : sim2_apn1_state} {sim2_apn1_active && `(Active)`}
                          </Col>

                          <div style={{ display: sim2_apn1_state !== "Disabled" ? "" : "none" }}>
                            <Col
                              span={24}
                              className={styles.colFontSize}
                              style={{ display: sim2_apn1_ip_address !== undefined ? "" : "none" }}
                            >
                              IP Address: {`${sim2_apn1_ip_address}`}
                            </Col>
                            <Col span={24}>
                              <Row>
                                <Col span={24} className={styles.colFontSize}>
                                  Ping {`${sim2_apn1_ping1}`}:
                                </Col>
                              </Row>
                              <Row className={styles.inspectRow}>
                                <Col span={24} className={styles.colFontSize}>
                                  Sent: {`${sim2_apn1_ping1_sent}`}, Received: {`${sim2_apn1_ping1_received}`}
                                </Col>
                              </Row>
                            </Col>
                            <Col span={24}>
                              <Row>
                                <Col span={24} className={styles.colFontSize}>
                                  Ping {`${sim2_apn1_ping2}`}:
                                </Col>
                              </Row>
                              <Row className={styles.inspectRow}>
                                <Col span={24} className={styles.colFontSize}>
                                  Sent: {`${sim2_apn1_ping2_sent}`}, Received: {`${sim2_apn1_ping2_received}`}
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        </div>

                        <div>
                          <Col span={24} className={styles.colFontSize}>
                            APN#2: {!sim2_apn2 ? sim2_apn2_name : sim2_apn2_state} {sim2_apn2_active && `(Active)`}
                          </Col>
                          <div style={{ display: sim2_apn2_state !== "Disabled" ? "" : "none" }}>
                            <Col
                              span={24}
                              className={styles.colFontSize}
                              style={{ display: sim2_apn2_ip_address !== undefined ? "" : "none" }}
                            >
                              IP Address: {`${sim2_apn2_ip_address}`}
                            </Col>
                            <Col span={24}>
                              <Row>
                                <Col span={24} className={styles.colFontSize}>
                                  Ping {`${sim2_apn2_ping1}`}:
                                </Col>
                              </Row>
                              <Row className={styles.inspectRow}>
                                <Col span={24} className={styles.colFontSize}>
                                  Sent: {`${sim2_apn2_ping1_sent}`}, Received: {`${sim2_apn2_ping1_received}`}
                                </Col>
                              </Row>
                            </Col>
                            <Col span={24}>
                              <Row>
                                <Col span={24} className={styles.colFontSize}>
                                  Ping {`${sim2_apn2_ping2}`}:
                                </Col>
                              </Row>
                              <Row className={styles.inspectRow}>
                                <Col span={24} className={styles.colFontSize}>
                                  Sent: {`${sim2_apn2_ping2_sent}`}, Received: {`${sim2_apn2_ping2_received}`}
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        </div>
                      </Space>
                    </>
                  ) : (
                    <Col span={24} className={styles.colFontSize}>
                      Status: SIM card is not inserted
                    </Col>
                  )}
                </Row>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <h2>WAN Ethernet {wan_active && `(Active)`}</h2>
                <Row className={styles.inspectRow}>
                  <Col span={24} className={styles.colFontSize}>
                    Status: {wan_state === "down" ? "Down" : `${wan_status}`}
                  </Col>
                  <Col
                    span={24}
                    className={styles.colFontSize}
                    style={{ display: wan_ip_address !== undefined ? "" : "none" }}
                  >
                    IP Address: {`${wan_ip_address}`}
                  </Col>
                  <Col span={24} style={{ display: wan_ping1 !== undefined ? "" : "none" }}>
                    <Row>
                      <Col span={24} className={styles.colFontSize}>
                        Ping {`${wan_ping1}`} {wan_gateway === 0 ? "(gateway)" : ""}:
                      </Col>
                    </Row>
                    <Row className={styles.inspectRow}>
                      <Col span={24} className={styles.colFontSize}>
                        Sent: {`${want_ping1_sent}`}, Received: {`${want_ping1_received}`}
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24} style={{ display: wan_ping2 !== undefined ? "" : "none" }}>
                    <Row>
                      <Col span={24} className={styles.colFontSize}>
                        Ping {`${wan_ping2}`} {wan_gateway === 1 ? "(gateway)" : ""}:
                      </Col>
                    </Row>
                    <Row className={styles.inspectRow}>
                      <Col span={24} className={styles.colFontSize}>
                        Sent: {`${want_ping2_sent}`}, Received: {`${want_ping2_received}`}
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24} style={{ display: wan_ping3 !== undefined ? "" : "none" }}>
                    <Row>
                      <Col span={24} className={styles.colFontSize}>
                        Ping {`${wan_ping3}`} {wan_gateway === 2 ? "(gateway)" : ""}:
                      </Col>
                    </Row>
                    <Row className={styles.inspectRow}>
                      <Col span={24} className={styles.colFontSize}>
                        Sent: {`${want_ping3_sent}`}, Received: {`${want_ping3_received}`}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <h2>LAN Ports Status</h2>
                <Row className={styles.inspectRow}>
                  <Col span={24} className={styles.colFontSize}>
                    LAN1: {`${lan1}`}
                  </Col>
                  <Col span={24} className={styles.colFontSize}>
                    LAN2: {`${lan2}`}
                  </Col>
                  <Col span={24} className={styles.colFontSize}>
                    LAN3: {`${lan3}`}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        )}
      </Modal>
    </>
  );
};

export default InspectModal;
